import {
  IconClockHour4,
  IconBuildingCommunity,
  IconCircleCheck,
  IconCoin,
  IconCircleX,
  IconArchive,
} from "@tabler/icons-react";

import {
  ENROLLMENT_STATUS_LABEL,
  ENROLLMENT_STATUS_TONE,
  STATUS_CHIP_VARIANT,
} from "@pages/CommunityConfig/tabs/Mentoring/enums/enrollmentStatuses";
import { StatusChip } from "@fragments";

// Per-status icon (the creator chips carry an icon; the owner list chip doesn't).
// Keyed by enrollment status — see ClickUp 868jxkz4p §3.
const STATUS_ICON = {
  pending: IconClockHour4,
  awaiting_community: IconBuildingCommunity,
  active: IconCircleCheck,
  split_only: IconCoin,
  rejected: IconCircleX,
  declined: IconCircleX,
  ended: IconArchive,
};

/**
 * Creator-side enrollment status pill. Unlike the owner list chip (active →
 * Success, everything else → Default), this honours the full §3 tone map so
 * split_only reads as "Repasse ativo" (Info), pending as Alert, etc.
 */
export default function MentoringStatusChip({ status, withIcon = true }) {
  const tone = ENROLLMENT_STATUS_TONE[status] ?? "default";
  const Variant = StatusChip[STATUS_CHIP_VARIANT[tone] ?? "Default"];
  const Icon = STATUS_ICON[status];

  return (
    <Variant
      text={ENROLLMENT_STATUS_LABEL[status] ?? status}
      icon={withIcon && Icon ? <Icon size={13} /> : null}
    />
  );
}
